// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 3H20V22.9432L12 17.2289L4 22.9432V3Z"}}]};

const BookmarkFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'bookmark-filled',
    ref,
    icon: element,
  },
));

BookmarkFilledIcon.displayName = 'BookmarkFilledIcon';

export default BookmarkFilledIcon;
